import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/** Matches `ticketCardGridSize` / participant card grid: xs=1, sm=2, md=3, lg=4 */
export function useResponsiveColumnCount(): number {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  if (lgUp) return 4;
  if (mdUp) return 3;
  if (smUp) return 2;
  return 1;
}

export function chunkIntoRows<T>(items: T[], columnCount: number): T[][] {
  const rows: T[][] = [];
  for (let i = 0; i < items.length; i += columnCount) {
    rows.push(items.slice(i, i + columnCount));
  }
  return rows;
}
